import { renderModel } from '../../util/renderModel';
import { biLogger } from '../biLogger';
import { selectBiData } from '../selectors';
import { BiEventLogger } from '../types';
import { getRuntimeDataForBi } from '../utils';

export type RelatedArticleClickBiData = {
  articleId: string;
  articleOrder: number;
};

export const logRelatedArticleClick: BiEventLogger<RelatedArticleClickBiData> = async (
  state,
  { articleId, articleOrder },
) => {
  const biData = selectBiData(state);
  const { sessionId } = await getRuntimeDataForBi(state);

  const params = {
    chatbot_conversation_id: biData.conversationId,
    self_service_session_id: sessionId,
    target_account_id: renderModel.getAccountId(),
    article_id: articleId,
    article_language: renderModel.getLocale(),
    article_order: articleOrder,
  };

  await biLogger.fullContactPageArticleView(state, params);
};
